// extracted by mini-css-extract-plugin
export default {"headerRow":"SimpleTabs_headerRow__RMspe","customNavTabs":"SimpleTabs_customNavTabs__uQJJB"};